module.exports = __webpack_public_path__ + "static/img/product_images_big2_h5_zh.f08e6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_big2_h5_zh.png
// module id = rw++
// module chunks = 34